import AutoCarousel from "./Components/AutoCarousel";
import './App.css'
import Navbars from './Components/Navbar'
import AppRoutes from "./AppRoutes.js/AppRoutes";

function App() {
  return (
    <div>
     
     <AppRoutes/>
    </div>
  );
}

export default App;
